import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import {observable, action} from "mobx";
import {observer} from "mobx-react";
import {DialogAncestor} from "core/common/page/dialogAncestor";
import EmailBodyEditor from "core/components/editors/emailBodyEditor";
import {EditorState} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';

interface NoteDialogProps {
  title: string;
}

@observer
export default class NoteDialog extends DialogAncestor<NoteDialogProps, undefined, string> {

  @observable private editorState: EditorState;

  @action open(resolve, reject) {
    console.log('NoteDialog: Opening dialog');

    this.resolve = resolve;
    this.reject = reject;
    this.$errors = null;
    this.editorState = EditorState.createEmpty();
    this.dialogOpen = true;
  }



  @action ok = () => {
    console.log('NoteDialog OK');
    this.dialogOpen = false;
    this.resolve(stateToHTML(this.editorState.getCurrentContent()));
  };


  @action cancel = (evt) => {
    console.log('NoteDialog#cancel evt = %O', evt);
    this.dialogOpen = false;
    this.reject(null);
  };

  @action onChangeNote = (editorState) => {
    this.editorState = editorState;
  };


  render() {
    if (!this.dialogOpen) return null;

    return (
      <Dialog
        actions={[<FlatButton label="Cancel" tabIndex={0} primary onClick={this.cancel}/>,
          <FlatButton label="Ok" disabled={!this.editorState.getCurrentContent().hasText()} secondary onClick={this.ok}/>
        ]}
        modal={true}
        title={this.props.title}
        open={this.dialogOpen}
        contentStyle={{width: '80%', maxWidth: 800}}
        bodyStyle={{overflowY: 'auto'}}
      >

          <ErrorComp messages={this.$errors}/>
          <EmailBodyEditor editorState={this.editorState} onChange={this.onChangeNote} style={{height: 400}}/>

      </Dialog>
    );
  }

}






// WEBPACK FOOTER //
// ./src/core/components/dialogs/noteDialog.tsx